import { NetGainByScheduledPayementDateOutput } from '@allocab/allocab-invoice-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchIncomingTransactions = () => {
  return driverApi.get<void, NetGainByScheduledPayementDateOutput, 'list'>('/v1/net-gains/by-scheduled-payement-dates');
};

export const useFetchIncomingTransactions = () => {
  return useQuery({ queryKey: queryKeys.user.fetchIncomingTransactions(), queryFn: fetchIncomingTransactions });
};
